import React, {useState} from 'react';
import {isWidthUp, makeStyles, useMediaQuery, useTheme, withWidth} from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer';
import ContainerDimensions from 'react-container-dimensions';
import MainToolbar from './MainToolbar';
import Map from './map/Map';
import CurrentLocationMap from './map/CurrentLocationMap';
import GeofenceEditMap from './map/GeofenceEditMap';
import GeofenceMap from './map/GeofenceMap';
import GeofencesList from './GeofencesList';
import {FormDialog} from "./map/FormDialog";
import { geofencesActions } from './store';
import {useDispatch, useSelector} from "react-redux";
import ButtonsHistory from "./shared/ButtonsHistory";
import {cyberStyles} from "./cssShared/cyberTheme";
import ButtonsHistoryMobile from "./shared/ButtonsHistoryMobile";

const useStyles = makeStyles(theme => ({
  ...cyberStyles(theme),
  buttonsHistory: {
    marginTop: 'auto',
    paddingBottom: 0,
    marginBottom: 0,
  },
}));

const GeofencesPage = ({ width }) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const subadminEnabled = useSelector(state => state.session.user && state.session.user.subadmin)
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [open, setOpen] = React.useState(false);


  const refreshGeofences = async () => {
         console.log("--------------------------------");
 const response = await fetch('/api/geofences');
    if (response.ok) {
      let res = await response.json();

      console.log(res);
      dispatch(geofencesActions.refresh(res));
    }
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    if (newItem.id === undefined) {
      window.dispatchEvent(new CustomEvent('geofence.cancel'));
    }
  };

  const [newItem, setNewItem] = useState({ name: '', area: ''});

  return (
      <div className={classes.geofenceRoot }>
        {!isMobile && <MainToolbar/>}

        <div className={classes.geofenceContent}>
          <Drawer
              anchor={isWidthUp('sm', width) ? 'left' : 'bottom'}
              variant='permanent'
              classes={{ paper: classes.geofenceDrawerPaper }}>
            <GeofencesList />
            {!isMobile ?
                <div className={classes.buttonsHistory}>
                  <ButtonsHistory/>
                </div>
                :
                <div className={classes.buttonsHistory}>
                  <ButtonsHistoryMobile/>
                </div>
            }
          </Drawer>
          <div className={classes.mapContainer}>
            <ContainerDimensions>
              <Map>
                <CurrentLocationMap />
                {subadminEnabled ?
                    // GeofenceEditMap renders the existing geofences itself (as
                    // editable draw features) on top of the draw tool.
                    <GeofenceEditMap
                        refreshGeofences={refreshGeofences}
                        newItem={newItem} setNewItem={setNewItem}
                        handleClickOpen={handleClickOpen}
                    />
                    :
                    // Without edit rights there is no draw layer, so geofences
                    // need the read-only layer to stay visible (same role
                    // GeofenceMapGoogle plays on the Google page).
                    <GeofenceMap />
                }
              </Map>
            </ContainerDimensions>
          </div>
          <FormDialog refreshGeofences={refreshGeofences} newItem={newItem} setNewItem={setNewItem} open={open} handleClose={handleClose}/>
        </div>
      </div>
  );
}

export default withWidth()(GeofencesPage);
